import MainLayout from './pages/Home';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import CreditDashboard from './pages/CreditDashboard';
import UserManagement from './pages/UserManagement';
import Analytics from './pages/Analytics.jsx';
import CustomDomain from './pages/CustomDomain';
import LandingPage from './pages/LandingPage';
import QRCodes from './pages/QRCodes';
import APIKeyDashboard from './pages/APIKeyDashboard';
import CompanyManagement from './pages/CompanyManagement';
import SingleBulkUrl from  './pages/SingleBulkUrl.jsx'
import EmailVerification from './pages/EmailVerification';
import VerifyLink from '../src/components/VerifyLink.jsx';
import ResetPassword from './components/ResetPassword.jsx';
import AccountManagement from './pages/AccountManagement';
import SuperAdminUserManagement from './pages/SuperAdminUserManagement';
import CreditRequests from './pages/CreditRequests';
import Reports from './pages/Reports';
import HelpCenter from './pages/HelpCenter';
import Connectors from './pages/Connectors';

export const routes = [
  {
    path: "/",
    component: LandingPage
  },
  {
    path: "/auth/login",
    component: Login
  },
  {
    path: "/auth/signup",
    component: SignUp
  },
  {
    path: "/auth/forgot-password",
    component: ForgotPassword
  },
  {
    path: "/auth/verify-email",
    component: EmailVerification
  },
  {
    path: "/auth/verify-link",
    component: VerifyLink
  },
  {
    path: "/auth/reset-password/link",
    component: ResetPassword
  },
  {
    path: "*",
    component: MainLayout,
    children: [
      {
        path: "analytics",
        component: Analytics
      },
      {
        path: "credit-requests",
        component: CreditRequests
      },
      {
        path: "custom-domain",
        component: CustomDomain
      },
      {
        path: "qr-codes",
        component: QRCodes
      },
      {
        path: "api-key",
        component: APIKeyDashboard
      },
      {
        path: "company-management",
        component: CompanyManagement
      },
      {
        path: "urlShorten",
        component: SingleBulkUrl
      },
      {
        path: "profile",
        component: Profile
      },
      {
        path: "credit-management",
        component: CreditDashboard
      },
      {
        path: "dashboard",
        component: Analytics
      },
      {
        path: "user-management",
        component: UserManagement
      },
      {
        path: "account-management",
        component: AccountManagement,
      },
      {
        path: "account-management/:accountId",
        component: AccountManagement,
      },
      {
        path: "account-management/:accountId/details",
        component: AccountManagement,
      },
      {
        path: "account-management/:accountId/user-management",
        component: AccountManagement,
      },
      {
        path: "account-management/:accountId/credit-management",
        component: AccountManagement,
      },
      {
        path: "super-admin-users",
        component: SuperAdminUserManagement
      },
      {
        path: "reports",
        component: Reports
      },
      {
        path: "help",
        component: HelpCenter
      }
      ,
      {
        path: "connectors",
        component: Connectors
      }
    ]
  }
];